/**
 * HomeSection — غلاف موحَّد لكلّ بلوك في الصفحة الرئيسيّة.
 *
 * القاعدة: الفاصل (HomeBlockDivider) ليس عنصراً مستقلّاً في الصفحة، بل جزء من
 * البلوك نفسه ويظهر فقط إذا كان البلوك يعرض محتوى فعلاً.
 * لذلك عند تعطيل بلوك من الأدمن (أو إخفائه على جهاز معيّن) يختفي فاصله معه
 * ولا تبقى خطوط معلَّقة في الهوم.
 */
import * as React from "react";
import { HomeBlockDivider } from "@/components/HomeBlockDivider";

export function HomeSection({
  children,
  first = false,
}: {
  children: React.ReactNode;
  first?: boolean;
}) {
  const ref = React.useRef<HTMLDivElement>(null);
  // نبدأ بـ«فارغ» لئلّا يظهر خطّ لحظة التحميل قبل معرفة حالة البلوك
  const [hasContent, setHasContent] = React.useState(false);

  React.useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const measure = () => setHasContent(el.offsetHeight > 8);
    measure();
    const ro = new ResizeObserver(measure);
    ro.observe(el);
    const t = window.setTimeout(measure, 800);
    window.addEventListener("resize", measure);
    return () => {
      ro.disconnect();
      window.clearTimeout(t);
      window.removeEventListener("resize", measure);
    };
  }, []);

  return (
    <>
      {!first && hasContent ? <HomeBlockDivider /> : null}
      <div ref={ref} data-home-section={hasContent ? "filled" : "empty"}>
        {children}
      </div>
    </>
  );
}
